import { motion } from "framer-motion";
import { Cloud, CloudOff } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface SyncStatusProps {
  isSyncing: boolean;
  isOnline: boolean;
}

export const SyncStatus = ({ isSyncing, isOnline }: SyncStatusProps) => {
  const { t } = useLanguage();
  
  if (!isOnline) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <CloudOff className="w-4 h-4" />
        <span>{t('sync.offline')}</span>
      </div>
    );
  }

  if (isSyncing) {
    return (
      <motion.div
        className="flex items-center gap-2 text-sm text-muted-foreground"
        animate={{ opacity: [1, 0.5, 1] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <Cloud className="w-4 h-4" />
        <span>{t('sync.syncing')}</span>
      </motion.div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm text-green-600 dark:text-green-400">
      <Cloud className="w-4 h-4" />
      <span>{t('sync.synced')}</span>
    </div>
  );
};
